/**
 * Business Type
 */
export class BusinessTypeModel {
  /**
   * @constructor
   */
  constructor(public id: string, public name: string) {}
}
